var accountModule = angular.module('t2g.account', [
  'ui.router',
  require('t2g.common.services.modelService').name,
]);

module.exports = accountModule;

accountModule.config(function($stateProvider) {
  $stateProvider
    .state('private.main.account', {
      url: '/account',
      title: 'Account',
      templateUrl: '/app/modules/account/AccountView.html?v=4.5.6',
      controller: 'AccountCtrl',
    })
    .state('private.main.logout', {
      url: '/logout',
      template: '',
      resolve: {
        logout: function($q, AccountModel) {
          var deffered = $q.defer();

          AccountModel.logout(function(error, response) {
            if (error) {
              deffered.reject(error);
            } else {
              deffered.resolve(response);
            }
          });

          return deffered.promise;
        },
      },
    });
});

accountModule.controller('AccountCtrl', function($scope, AccountModel) {
  /**
   * overwrite password of user account
   */
  $scope.save = function() {
    AccountModel.changePassword($scope.account, function(error) {
      if (error) {
        console.log(error);
      } else {
        AccountModel.logout($scope.account, function(error) {
          if (error) {
            console.log(error);
          }
        });
      }
    });
  };
});



// WEBPACK FOOTER //
// ./src/app/modules/account/accountModule.js